import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import cn from 'classnames';
import { IconButton } from '../IconButton/IconButton.js';
import { useAnimation, motion } from 'framer-motion';
import useTimer from '../../utils/hooks/useTimer.js';
import { getBadgeIcon } from './util.js';
import { useGaudiLocalization } from '../Provider/Provider.js';

var _excluded = ["content", "lastUpdated", "onClose", "options"];
var Toast = function Toast(_ref) {
  var content = _ref.content,
      lastUpdated = _ref.lastUpdated,
      handleClose = _ref.onClose,
      options = _ref.options,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useGaudiLocalization = useGaudiLocalization(),
      texts = _useGaudiLocalization.texts;

  var autoClose = options.autoClose,
      _options$type = options.type,
      type = _options$type === void 0 ? 'default' : _options$type;
  var className = cn('yt-toast', {
    'border border-grey-darker': type === 'success',
    'border border-blue': type === 'information',
    'border border-yellow-dark': type === 'warning',
    'border border-red': type === 'error'
  });
  var timer = useTimer(autoClose, handleClose);
  var controls = useAnimation();
  React__default.useEffect(function () {
    if (autoClose) {
      timer.start();
    }
  }, [autoClose]);

  var triggerUpdateAnimation = function triggerUpdateAnimation() {
    try {
      return Promise.resolve(controls.start({
        scale: 1.05
      })).then(function () {
        return Promise.resolve(controls.start({
          scale: 1
        })).then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  React__default.useEffect(function () {
    if (lastUpdated) {
      triggerUpdateAnimation();

      if (timer.running) {
        timer.start();
      }
    }
  }, [lastUpdated]);
  return React__default.createElement(motion.div, Object.assign({}, props, {
    animate: controls,
    className: className,
    onMouseEnter: timer.pause,
    onMouseLeave: timer.resume
  }), getBadgeIcon(type), content && React__default.createElement("div", {
    className: "yt-toast__content flex-grow"
  }, content), React__default.createElement(IconButton, {
    appearance: "discrete",
    className: "text-grey-darkest cursor-pointer -mr-2",
    icon: "close",
    "aria-label": texts.toasts.dismiss,
    onClick: handleClose
  }));
};

export { Toast };
//# sourceMappingURL=Toast.js.map
